import { useState } from "react";
import { Flex } from "rebass/styled-components";
import styled from "styled-components";

import { useAnalyticsContext } from "MVVM/Hooks/useAnalyticsContext";

interface FilterPillBarProps {
  filters: Array<{
    label: string;
    key: string;
    count: number;
    externalLink?: boolean;
  }>;
  selected?: string;
  onSelect?: (key: string) => void;
}

export const FilterPillBar = ({
  filters,
  selected,
  onSelect,
}: FilterPillBarProps) => {
  const [internalSelected, setInternalSelected] = useState("");
  const { track } = useAnalyticsContext();

  const currentSelected = selected !== undefined ? selected : internalSelected;
  const handleSelect = onSelect || setInternalSelected;

  const handlePillClick = (filter: { key: string; externalLink?: boolean }) => {
    if (filter.externalLink) {
      track("Button - Click", {
        locationIdentifier: "more_pill",
        location: "embeddable_playlist",
      });
      const ajs_aid = window.rudderanalytics.getAnonymousId();
      const utmSource =
        new URLSearchParams(window.location.search).get("platform") ||
        "unknown";
      window.open(
        `https://allstar.gg/u/HLTV?utm_source=${utmSource}&ajs_aid=${ajs_aid}`,
        "_blank",
      );
    } else {
      track("Button - Click", {
        locationIdentifier: "filter_pill_bar",
        location: "embeddable_playlist",
      });
      handleSelect(filter.key);
    }
  };

  return (
    <StyledContainer>
      {filters.map(({ label, key, count, externalLink }) => (
        <Pill
          className="filter-pill"
          key={key}
          active={!externalLink && currentSelected === key}
          onClick={() => handlePillClick({ key, externalLink })}
        >
          {label}
          {!externalLink && <PillCount>{count}</PillCount>}
        </Pill>
      ))}
    </StyledContainer>
  );
};

const Pill = styled(Flex)<{ active: boolean }>`
  background: ${({ active, theme }) =>
    active ? theme.colors.navy300 : theme.colors.navy600};
  border: ${({ active, theme }) =>
    active
      ? `1px solid ${theme.colors.envy}`
      : `1px solid ${theme.colors.navy600}`};
  border-radius: 20px;
  color: ${({ theme }) => theme.colors.ice};
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  gap: 4px;
  padding: 7px 10px;

  @media (max-width: 515px) {
    font-size: 12px;
    padding: 3px 6px;
  }
`;

const PillCount = styled.span`
  color: ${({ theme }) => theme.colors.iceAlpha40};
`;

const StyledContainer = styled(Flex)`
  gap: 8px;

  @media (max-width: 360px) {
    gap: 6px;
  }
`;
